import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import useHomeBannerStyles from '../../styles/kozelDarkQuiz/homeBanner';
import { paths } from '../../AppRouters';
import tap from '../../assets/images/kozel_dark_quiz/ecran1_tap.png';
import doze from '../../assets/images/kozel_dark_quiz/ecran_1_doze.png';
import logo from '../../assets/images/kozel_dark_quiz/logoDark.png';

const HomeBanner: React.FC = () => {
  const bannerStyles = useHomeBannerStyles();
  const navigate = useNavigate();

  const handleQuizClick = () => {
    navigate(paths.KozelDarkQuiz);
  };

  return (
    <Box className={bannerStyles.bannerContainer}>
      {/* Text Panel - stânga */}
      <Box className={bannerStyles.textPanel}>
        <Typography className={bannerStyles.mainText}>
          Găsește-ți
        </Typography>
        <Typography className={bannerStyles.brandText}>
          mixul ușor de <br /> băut!
        </Typography>
        <Box className={bannerStyles.logoContainer}>
           <Typography className={bannerStyles.text}>
             Completează quiz-ul și poți câștiga voucher 20% discount
          </Typography>
          {/* <Typography className={bannerStyles.text}>
             Completează quiz-ul și vezi ce tipologie țapănă ai!
          </Typography> */}
        </Box>
        <Button 
          onClick={handleQuizClick}
          className={bannerStyles.quizButton}
          variant="contained"
        >
          Mergi la quiz
        </Button>
      </Box>

      {/* Doze - centru */}
      <Box className={bannerStyles.dozeContainer}>
        <img 
          src={doze} 
          alt="Kozel Doze" 
          className={bannerStyles.dozeImage}
        />
      </Box>

      {/* Țap - dreapta sus */}
      <Box className={bannerStyles.tapContainer}>
        <img 
          src={tap} 
          alt="Kozel Țap" 
          className={bannerStyles.tapImage}
        />
      </Box>
    </Box>
  );
};

export default HomeBanner;